import feedbackUrl from './feedback.html';
class FeedbackCtrl {
  constructor($http, Authentication, SlingAnalytics) {
    'ngInject';

    Object.assign(this, { $http, Authentication, SlingAnalytics });
  }

  $onInit() {
    if (this.eventOnOpen) {
      this.SlingAnalytics.track(this.eventOnOpen);
    }

    this.submitted = false;
  }

  async save(form) {
    if (form.$invalid) {
      throw new Error();
    }
    this.submitted = true;

    this._sendForm();

    if (this.eventOnSend) {
      this.SlingAnalytics.track(this.eventOnSend, this.opinion);
    }
  }

  _sendForm() {
    return this.$http({
      method: 'POST',
      url: this.url,
      data: [
        `Name=${encodeURIComponent(this.Authentication.user.fullname)}`,
        `Email=${encodeURIComponent(this.Authentication.user.email)}`,
        `Opinion=${encodeURIComponent(this.opinion)}`,
        `Org=${encodeURIComponent(this.Authentication.user.org.name)}`,
      ].join('&'),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  }
}

export default {
  controller: FeedbackCtrl,
  bindings: {
    url: '@',
    image: '@',
    placeholder: '@',
    eventOnOpen: '@?',
    eventOnSend: '@?',
  },
  transclude: true,
  controllerAs: 'ctrl',
  templateUrl: feedbackUrl,
};
